export default "__VITE_ASSET__d83c530a__"